import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Divider from "@material-ui/core/Divider";
import LoadingOverlay from 'react-loading-overlay';

const MaintenanceInstitution = ({...props}) => {
    return (
        <React.Fragment>
            <LoadingOverlay
                active={props.isLoading}
                spinner
                text='Loading...'
            >
                {props.messagesGrowl}
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TitlePage title="Mantenimientos \ Instituciones"/>
                        </Grid>
                        <Grid item xs={6}>
                            <Button label="Buscar" style={{'float': 'right'}}
                                    onClick={props.getInstitutions}/>
                        </Grid>
                        <Grid item xs={12}> <Divider/> </Grid>
                        <Grid item xs={12}>
                            <div style={{textAlign: 'right'}}>
                                <Button type="button" iconPos="left" label="Agregar"
                                        style={{marginRight: '.5em'}}
                                        className="p-button-secondary"
                                        onClick={props.insertInstitutionScreen}/>
                                <Button type="button" iconPos="left" label="Exportar"
                                        className="p-button-secondary"
                                        onClick={props.exportXLS}/>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="content-section implementation">
                                <DataTable
                                    value={props.institutionList}
                                    selectionMode="single"
                                    responsive={true}
                                    resizableColumns={true}
                                    columnResizeMode={"fit"}>
                                    <Column field="nombreCorto" header="Institución"
                                            style={{textAlign: 'left'}} sortable={true}/>
                                    <Column field="descripcionRol" header="Rol"
                                            style={{textAlign: 'left'}} sortable={true}/>
                                    <Column field="descriptionOtc" header="Tipo Préstamo"
                                            style={{textAlign: 'left'}} sortable={true}/>
                                    <Column field="banderaIndeval" header="Indeval"
                                            style={{textAlign: 'left'}}
                                            body={(rowData) => (rowData && rowData['banderaIndeval'] === 1) ?
                                                "SI" : "NO"} sortable={true}/>
                                    <Column field="seleccionGaran" header="Garantía"
                                            style={{textAlign: 'left'}}
                                            body={(rowData) => (rowData && rowData['seleccionGaran'] === 1) ?
                                                "SI" : "NO"} sortable={true}/>
                                    <Column field="contrato" header="Contrato"
                                            style={{textAlign: 'left'}}
                                            body={(rowData) => rowData ?
                                                rowData['contrato'] === '0' ? '' : rowData['contrato'] : ''}
                                            sortable={true}/>
                                    <Column field="nombreCliente" header="Cte. GSS"
                                            style={{textAlign: 'left'}} sortable={true}/>
                                    <Column field="status" header="Estatus"
                                            style={{textAlign: 'left'}} sortable={true}/>
                                    <Column header="Acciones"
                                            body={props.editInstitutionActionTemplate}
                                            style={{textAlign: 'center', width: '8em'}}/>
                                </DataTable>
                            </div>
                        </Grid>
                    </Grid>
                </Paper>
            </LoadingOverlay>
        </React.Fragment>
    )
};

export default MaintenanceInstitution;